export const ROUTES = {
  login: '/login',
  callback: '/callback',
  home: '/',
  reviewStatus: '/review-status',
  reviewKpis: '/review-status/review-kpis',
  marketingInvests: '/review-status/marketing-invests',
  reviewPerformance: '/review-performance',
  collections: '/collections',
  collectionsShared: '/collections/shared',
  profile: '/profile',
  account: '/account',
} as const
